function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 2",
  viewBox: "0 0 55.37 50"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M43.75 0h8.49L33.61 21.22 55.38 50H38.3L24.92 32.51 9.61 50h-8.5l19.74-22.69L0 0h17.51l12.08 15.98zm-2.98 45.02h4.7L15.04 4.8H9.98z",
  "data-name": "Layer 1",
  style: {
    fill: "#102a56"
  }
}));
export default SvgXIcon;